import SEO_JSON from "./seo.json";

// Single source of truth for per-page titles/descriptions; also read at build time by
// plugins/route-heads/route-heads-plugin.js to emit per-route index.html files.
export const SEO = SEO_JSON;
